import logo from './spinner.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Welcome to Pordoor.
        </p>
        <p>
          When it rains. It pors.
        </p>
          <p>
          For more information contact <a href="mailto:info@pordoor.com">info@pordoor.com</a>
        </p>

      </header>
    </div>
  );
}

export default App;
